import Image from 'next/image';
import { enqueueSnackbar } from 'notistack';
import type { FC } from 'react';
import React from 'react';
import { Button } from '@/DesignSystem/Component';
import HeaderBarWelcome from '@/Module/Auth/Component/HeaderBarWelcome/HeaderBarWelcome';
import { useCompleteSteps } from '@/Module/Auth/Hook';
import { authUpdatePersonAction, postFreeTrialAction } from '@/Module/Auth/Store/Action';
import { setSectionWelcome } from '@/Module/Auth/Store/Slice/AuthSlice';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { enqueueError } from '@/Module/Core/Helper';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const FreeSubscription: FC = () => {
  const dispatch = useAppDispatch();
  const person = useAppSelector(state => state.auth.person!);
  const onCompleteSteps = useCompleteSteps();
  const onClick = () => {
    dispatch(postFreeTrialAction()).then(data => {
      if (data.payload) {
        enqueueSnackbar({
          variant: 'success',
          message: 'اشتراک رایگان به شما اختصاص یافت!'
        });
      } else enqueueError('این اشتراک پیش‌تر، یک‌بار به شما اختصاص یافته است!');
    });
    dispatch(authUpdatePersonAction({
      id: person!.id,
      fundametalId: person?.fundametalId,
      gender: person?.gender,
      name: person?.name,
      family: person?.family,
      gradeId: person?.gradeId,
      fieldId: person?.fieldId || null,
      birthDate: person?.birthDate || null,
      stateId: person?.stateId || undefined,
      cityId: person?.cityId || undefined,
      isComplete: true
    })).then(() => onCompleteSteps({
      isLogin: false
    }));
    localStorage.setItem('step', '510');
    dispatch(setSectionWelcome(510));
  };
  return <div data-sentry-component="FreeSubscription" data-sentry-source-file="FreeSubscription.tsx">
      <HeaderBarWelcome step={3} data-sentry-element="HeaderBarWelcome" data-sentry-source-file="FreeSubscription.tsx" />
      <div className="my-4 text-xl font-extrabold text-blueFive">فعال‌سازی اشتراک رایگان آی‌نو</div>
      <div className="mb-4 text-blueFive">
        3 روز اشتراک رایگان رو فعال کن و اول ویدیوها رو ببین برای خرید اشتراک تصمیم بگیر.
      </div>
      <Image alt="free-subscription" src={`${FILE_BROWSER_URL}/img/Free_Subscription.webp`} priority width={280} height={334} className="mx-auto" data-sentry-element="Image" data-sentry-source-file="FreeSubscription.tsx" />
      <Button id="free_subscription" bold className="relative mt-4 w-full" variant="shadow" color="primary" radius="circle" size="large" onClick={onClick} data-sentry-element="Button" data-sentry-source-file="FreeSubscription.tsx">
        شروع یادگیری
      </Button>
    </div>;
};
export default FreeSubscription;